/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Country } from './Country';
import {
    CountryFromJSON,
    CountryFromJSONTyped,
    CountryToJSON,
} from './Country';
import type { Region } from './Region';
import {
    RegionFromJSON,
    RegionFromJSONTyped,
    RegionToJSON,
} from './Region';

/**
 * Address object
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * Unique id value of the address which is optional while creating new address. While performing other address operations this value is the key
     * @type {string}
     * @memberof Address
     */
    id?: string;
    /**
     * Title of the address person
     * @type {string}
     * @memberof Address
     */
    title?: string;
    /**
     * Code of the title
     * @type {string}
     * @memberof Address
     */
    titleCode?: string;
    /**
     * First name of the address person
     * @type {string}
     * @memberof Address
     */
    firstName?: string;
    /**
     * Last name of the address person
     * @type {string}
     * @memberof Address
     */
    lastName?: string;
    /**
     * Company Name
     * @type {string}
     * @memberof Address
     */
    companyName?: string;
    /**
     * First line of the address
     * @type {string}
     * @memberof Address
     */
    line1?: string;
    /**
     * Second line of the address
     * @type {string}
     * @memberof Address
     */
    line2?: string;
    /**
     * Town, field required
     * @type {string}
     * @memberof Address
     */
    town?: string;
    /**
     * 
     * @type {Region}
     * @memberof Address
     */
    region?: Region;
    /**
     * District name
     * @type {string}
     * @memberof Address
     */
    district?: string;
    /**
     * Postal code of the address
     * @type {string}
     * @memberof Address
     */
    postalCode?: string;
    /**
     * Phone number
     * @type {string}
     * @memberof Address
     */
    phone?: string;
    /**
     * Cellphone number
     * @type {string}
     * @memberof Address
     */
    cellphone?: string;
    /**
     * Email address
     * @type {string}
     * @memberof Address
     */
    email?: string;
    /**
     * 
     * @type {Country}
     * @memberof Address
     */
    country?: Country;
    /**
     * Boolean flag if address is for shipping
     * @type {boolean}
     * @memberof Address
     */
    shippingAddress?: boolean;
    /**
     * Boolean flag if address is default
     * @type {boolean}
     * @memberof Address
     */
    defaultAddress?: boolean;
    /**
     * Boolean flag if address is visible in the Address Book
     * @type {boolean}
     * @memberof Address
     */
    visibleInAddressBook?: boolean;
    /**
     * Boolean flag if address is formatted
     * @type {string}
     * @memberof Address
     */
    formattedAddress?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    billingAddress?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    contactAddress?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    defaultShippingAddress?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    defaultBillingAddress?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    shippingCostCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    ifsId?: string;
}

/**
 * Check if a given object implements the Address interface.
 */
export function instanceOfAddress(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AddressFromJSON(json: any): Address {
    return AddressFromJSONTyped(json, false);
}

export function AddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): Address {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'titleCode': !exists(json, 'titleCode') ? undefined : json['titleCode'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'line1': !exists(json, 'line1') ? undefined : json['line1'],
        'line2': !exists(json, 'line2') ? undefined : json['line2'],
        'town': !exists(json, 'town') ? undefined : json['town'],
        'region': !exists(json, 'region') ? undefined : RegionFromJSON(json['region']),
        'district': !exists(json, 'district') ? undefined : json['district'],
        'postalCode': !exists(json, 'postalCode') ? undefined : json['postalCode'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'cellphone': !exists(json, 'cellphone') ? undefined : json['cellphone'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'country': !exists(json, 'country') ? undefined : CountryFromJSON(json['country']),
        'shippingAddress': !exists(json, 'shippingAddress') ? undefined : json['shippingAddress'],
        'defaultAddress': !exists(json, 'defaultAddress') ? undefined : json['defaultAddress'],
        'visibleInAddressBook': !exists(json, 'visibleInAddressBook') ? undefined : json['visibleInAddressBook'],
        'formattedAddress': !exists(json, 'formattedAddress') ? undefined : json['formattedAddress'],
        'billingAddress': !exists(json, 'billingAddress') ? undefined : json['billingAddress'],
        'contactAddress': !exists(json, 'contactAddress') ? undefined : json['contactAddress'],
        'defaultShippingAddress': !exists(json, 'defaultShippingAddress') ? undefined : json['defaultShippingAddress'],
        'defaultBillingAddress': !exists(json, 'defaultBillingAddress') ? undefined : json['defaultBillingAddress'],
        'shippingCostCode': !exists(json, 'shippingCostCode') ? undefined : json['shippingCostCode'],
        'ifsId': !exists(json, 'ifsId') ? undefined : json['ifsId'],
    };
}

export function AddressToJSON(value?: Address | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'titleCode': value.titleCode,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'companyName': value.companyName,
        'line1': value.line1,
        'line2': value.line2,
        'town': value.town,
        'region': RegionToJSON(value.region),
        'district': value.district,
        'postalCode': value.postalCode,
        'phone': value.phone,
        'cellphone': value.cellphone,
        'email': value.email,
        'country': CountryToJSON(value.country),
        'shippingAddress': value.shippingAddress,
        'defaultAddress': value.defaultAddress,
        'visibleInAddressBook': value.visibleInAddressBook,
        'formattedAddress': value.formattedAddress,
        'billingAddress': value.billingAddress,
        'contactAddress': value.contactAddress,
        'defaultShippingAddress': value.defaultShippingAddress,
        'defaultBillingAddress': value.defaultBillingAddress,
        'shippingCostCode': value.shippingCostCode,
        'ifsId': value.ifsId,
    };
}

